import { render } from "./Decor.vue?vue&type=template&id=f842f020"
import script from "./Decor.vue?vue&type=script&lang=js"
export * from "./Decor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__